<template>
  <div
    class="in-stock"
    :class="badgeInfo.class"
  >
    <div class="in-stock__text-wrap">
      <img :src="badgeInfo.icon" alt="icon" />
      <span>{{ badgeInfo.text }}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProductInStock',
  computed: {
    ...mapState({
      inStock: state => state.productInfo.productInfo.inStock,
      isNovelty: state => state.productInfo.productInfo.isNovelty,
      isPreorder: state => state.productInfo.productInfo.isPreorder,
      isArchive: state => state.productInfo.productInfo.isArchive,
      price: state => state.productInfo.productInfo.price,
      availableInStore: state => state.productInfo.productInfo.availableInStore,
      productId: state => state.productInfo.productInfo.productId,
      isOnlyOnSite: state => state.productInfo.productInfo.isOnlyOnSite,
      arrivalDate: state => state.productInfo.productInfo.arrivalDate,
      productQuantityForEndsBadge: state => +state.productInfo.productInfo.productQuantityForEndsBadge,
      totalProductQuantity: state => state.productInfo.productInfo.totalProductQuantity
    }),
    badgeInfo () {
      // Ожидается в {month}, Доступно к предзаказу
      if (this.isPreorder && !this.isArchive) {
        return {
          icon: '/img/svgo/product-page/plus-circle.svg',
          text: this.$t('pre_order_available'),
          class: 'in-stock--preorder'
        }
      }
      // Только на сайте
      if (this.isOnlyOnSite && this.price) {
        return {
          icon: '/img/svgo/product-page/only-on-site.svg',
          text: this.$t('product_available_only_on_site'),
          class: 'in-stock--only-on-site'
        }
      }
      // Только для самовывоза
      if (this.availableInStore && this.price) {
        return {
          icon: '/img/svgo/product-page/only-in-store.svg',
          text: this.$t('product_available_only_in_store'),
          class: 'in-stock--only-in-store'
        }
      }
      // Заканчивается, Есть в наличии
      if (this.inStock && this.price) {
        const isProductEnds = this.totalProductQuantity < this.productQuantityForEndsBadge
        return {
          icon: isProductEnds ? '/img/svgo/product-page/alarm.svg' : '/img/svgo/product-page/in-stock.svg',
          text: isProductEnds ? this.$t('product_ends') : this.$t('product.in.stock'),
          class: isProductEnds ? 'in-stock--ends' : ''
        }
      }
      // Есть дата поступления
      if (this.arrivalDate) {
        return {
          icon: '/img/svgo/product-page/calendar.svg',
          text: this.arrivalDate,
          class: 'in-stock--arrival'
        }
      }
      // Ожидается в {month}, Доступно к предзаказу
      // if (this.isPreorder && !this.isArchive) {
      //   return {
      //     icon: '/img/svgo/product-page/plus-circle.svg',
      //     text: this.$t('pre_order_available'),
      //     class: 'in-stock--novelty'
      //   }
      // }
      // Нет в наличии
      return {
        icon: '/img/svgo/product-page/not-in-stock.svg',
        text: this.$t('out.of.stock'),
        class: 'in-stock--false'
      }
    }
  }
}
</script>

<style scoped lang="sass">

.in-stock
  //padding: 8px 20px
  //background: $nd-green-background-color
  color: $nd-green-text-color
  //border-radius: 5px
  font-size: 14px
  line-height: 1.2
  margin-bottom: 10px
  order: -1
  width: 100%

  +mmin($tablet)
    width: max-content
    margin-bottom: 14px
    order: 0

  &__arrival-date
    color: #333
    padding: 7px 15px
    background-color: #FFC700
    margin: 15px -15px 0
    display: block
    border-radius: 0
    text-align: center
    font-size: 16px
    +mmin($tablet)
      border-radius: 30px
      display: inline-block
      margin: 15px 0 0 0
      text-align: left
      font-size: 14px
  &--preorder
    color: #095E11

  &--arrival
    color: #333
    +mmax($tablet)
      padding: 4px 10px
      display: inline-flex
      border-radius: 3px
      background-color: #E7E7E7
      width: max-content

  &--false
    //background: $nd-gray-text-color
    color: rgba(51, 51, 51, 0.7)

  &--novelty
    //background: $nd-yellow-background-color
    color: $nd-yellow-text-color

  &--ends
    //background-color: rgba(255, 173, 50, 0.1)
    color: rgba(255, 47, 0, 0.8)

  &--only-on-site
    //background: rgba(204, 204, 204, 0.1)
    color: $nd-link-color

  &--only-in-store
    //background: rgba(62, 119, 170, 0.1)
    color: $nd-link-color

  img
    margin-right: 10px

.in-stock__text-wrap
  display: flex
  align-items: center

</style>
